export default __webpack_public_path__ + "static/media/sample-house.33edc565.jpg";